var map = {
	"./about/about-header.png": "2e08",
	"./about/about1.png": "a898",
	"./about/about2.png": "719c",
	"./about/aim.png": "1265",
	"./about/mission.png": "f3a5",
	"./about/vision.png": "8eea",
	"./about/we-are.png": "fd2a",
	"./bg-started.png": "90e6",
	"./blog-img.png": "b6af",
	"./complete.png": "6ac9",
	"./countries/country-1.png": "3358",
	"./countries/country-2.png": "6f0e",
	"./countries/country-3.png": "4ef6",
	"./countries/country-4.png": "0f17",
	"./countries/data.png": "9f0d",
	"./countries/hand.png": "3964",
	"./countries/rent.png": "e5cb2",
	"./countries/restaurant.png": "f395",
	"./countries/settings.png": "658c",
	"./countries/sport.png": "7585",
	"./countries/transportation.png": "c332",
	"./doctor-demo.png": "0e11",
	"./footer-bg.png": "ec49",
	"./general/doctor.png": "1693",
	"./head-blur-img.png": "4808",
	"./header-bg.png": "206d",
	"./home-about.png": "cc5a",
	"./how-it-works/left.png": "289e",
	"./how-it-works/right.png": "2b4a",
	"./how-it-works/step1-pro.png": "bc06",
	"./how-it-works/step1.png": "f865",
	"./how-it-works/step2-pro.png": "d384",
	"./how-it-works/step2.png": "243c",
	"./how-it-works/step3-pro.png": "535e",
	"./how-it-works/step3.png": "fe49",
	"./how-it-works/step4-pro.png": "36e9",
	"./how-it-works/step4.png": "7b24",
	"./logo-mini.png": "a2c8",
	"./logo-white.png": "06f1",
	"./logo.png": "9d64",
	"./register-bg-web.png": "e210",
	"./register-bg.png": "51f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";